"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var __1 = require("..");
function InteractiveList(_a) {
    var addItemLabel = _a.addItemLabel, options = _a.options, _b = _a.mode, mode = _b === void 0 ? "action" : _b, skeleton = _a.skeleton, onClickAddItem = _a.onClickAddItem, onChange = _a.onChange;
    var handleChangeAction = function (event) {
        onChange([event.name]);
    };
    var handleChangeCheck = function (event) {
        var newOptions = __spreadArray([], options, true);
        var optionIndex = newOptions.findIndex(function (option) { return option.name === event.name; });
        newOptions[optionIndex] = __assign(__assign({}, newOptions[optionIndex]), { active: event.checked });
        var activeOptions = newOptions
            .filter(function (option) { return option.active; })
            .map(function (option) { return option.name; });
        onChange(activeOptions);
    };
    var handleChangeRadio = function (event) {
        onChange([event.name]);
    };
    var renderActions = mode === "action" &&
        options.map(function (option, index) { return (React.createElement(__1.InteractiveListPriv.ActionItem, { key: index, title: option.title, name: option.name, description: option.description, labels: option.labels, skeleton: skeleton, onChange: handleChangeAction, hideBorder: option.hideBorder, blockLeft: option.blockLeft, icon: option.icon, iconAppearance: option.iconAppearance, disabled: option.disabled })); });
    var renderCheckBoxes = mode === "multi" &&
        options.map(function (option, index) { return (React.createElement(__1.InteractiveListPriv.CheckItem, { key: index, title: option.title, name: option.name, description: option.description, labels: option.labels, checked: option.active, skeleton: skeleton, onChange: handleChangeCheck, hideBorder: option.hideBorder, blockLeft: option.blockLeft, icon: option.icon, iconAppearance: option.iconAppearance, disabled: option.disabled })); });
    var renderCheckRadios = mode === "single" &&
        options.map(function (option, index) { return (React.createElement(__1.InteractiveListPriv.RadioItem, { key: index, title: option.title, value: option.name, description: option.description, labels: option.labels, checked: option.active, skeleton: skeleton, onChange: handleChangeRadio, hideBorder: option.hideBorder, blockLeft: option.blockLeft, icon: option.icon, iconAppearance: option.iconAppearance, disabled: option.disabled })); });
    return (React.createElement(__1.InteractiveListPriv, { addItemLabel: addItemLabel, skeleton: skeleton, onClickAddItem: onClickAddItem },
        renderActions,
        renderCheckBoxes,
        renderCheckRadios));
}
exports.default = InteractiveList;
//# sourceMappingURL=index.js.map